export const tcruziComparisonRows = [
  {
    fieldZh: "研究目标",
    fieldEn: "Study aim",
    laidlawZh: "体外生命周期图谱；覆盖昆虫期、哺乳动物期及分化轴",
    laidlawEn:
      "In-vitro lifecycle atlas spanning insect stages, mammalian stages and differentiation axes",
    inchaustiZh:
      "哺乳动物期混合群体；重点研究转唾液酸酶样超家族表达异质性",
    inchaustiEn:
      "Mixed mammalian-stage population focused on trans-sialidase-like superfamily expression heterogeneity",
  },
  {
    fieldZh: "目录细胞数",
    fieldEn: "Catalogue cells",
    laidlawZh: "31,065个质控后有效细胞",
    laidlawEn: "31,065 valid cells after author QC",
    inchaustiZh: "3,192个质控后细胞；去除41个双细胞后为3,151个",
    inchaustiEn:
      "3,192 post-QC cells; 3,151 remained after 41 doublets were removed",
  },
  {
    fieldZh: "样本结构",
    fieldEn: "Sample structure",
    laidlawZh:
      "8个来源样本、8个实验、25个ENA运行；样本1–7构成图谱，样本8用于48小时无鞭毛体验证",
    laidlawEn:
      "8 source samples, 8 experiments and 25 ENA runs; samples 1–7 form the atlas and sample 8 validates 48-hour amastigotes",
    inchaustiZh:
      "1个BioSample、1个实验、1个SRA运行；同一文库分两次技术测序并在公开代码中合并",
    inchaustiEn:
      "1 BioSample, 1 experiment and 1 SRA run; one library was sequenced in two technical runs and merged by the public code",
  },
  {
    fieldZh: "细胞阶段",
    fieldEn: "Cell stages",
    laidlawZh:
      "上鞭毛体、后循环型、细胞来源锥鞭毛体、6/24/120小时无鞭毛体及混合样本",
    laidlawEn:
      "Epimastigotes, metacyclics, cell-derived trypomastigotes, 6/24/120-hour amastigotes and a mixed sample",
    inchaustiZh: "无鞭毛体、过渡细胞、细胞来源锥鞭毛体",
    inchaustiEn:
      "Amastigotes, transitional cells and cell-derived trypomastigotes",
  },
  {
    fieldZh: "10x化学体系",
    fieldEn: "10x chemistry",
    laidlawZh:
      "Chromium Next GEM Single Cell 3′ v3.1；第二生物学重复使用v3.1 Dual Index",
    laidlawEn:
      "Chromium Next GEM Single Cell 3′ v3.1; the second biological replicate used v3.1 Dual Index",
    inchaustiZh:
      "Chromium Next GEM Single Cell 3′ v3.1；样本在上机前进行甲醇固定",
    inchaustiEn:
      "Chromium Next GEM Single Cell 3′ v3.1 after methanol fixation",
  },
  {
    fieldZh: "参考与定量",
    fieldEn: "Reference & quantification",
    laidlawZh:
      "Dm28c 2018；3′UTR延长2,500 bp；Cell Ranger v6.0.0，并进一步使用更新UTR边界分析",
    laidlawEn:
      "Dm28c 2018 with 3′ UTRs extended by 2,500 bp; Cell Ranger v6.0.0, plus analysis with updated UTR boundaries",
    inchaustiZh:
      "Dm28c release 62 + maxicircle；peaks2UTR得到11,362个3′UTR；kallisto bustools 0.51.1",
    inchaustiEn:
      "Dm28c release 62 plus maxicircle; 11,362 3′ UTRs from peaks2UTR; kallisto bustools 0.51.1",
  },
  {
    fieldZh: "基因数量口径",
    fieldEn: "Gene-count boundary",
    laidlawZh:
      "论文：15,321个检测到的基因；作者H5AD表达特征空间同为15,321",
    laidlawEn:
      "Paper: 15,321 detected genes; the author H5AD expression feature space also contains 15,321",
    inchaustiZh:
      "论文：14,321个至少在一个细胞中检测到的基因；存档矩阵含19,132个特征——两者不是同一概念",
    inchaustiEn:
      "Paper: 14,321 genes detected in at least one cell; deposited matrices contain 19,132 features—these are different concepts",
  },
  {
    fieldZh: "公开处理结果",
    fieldEn: "Public processed outputs",
    laidlawZh:
      "作者CELLxGENE图谱公开UMAP、细胞元数据和处理表达视图；BioStudies本身未提供处理计数矩阵",
    laidlawEn:
      "Author CELLxGENE atlas exposes UMAP, cell metadata and a processed expression view; BioStudies itself has no processed count matrix",
    inchaustiZh:
      "Zenodo提供17个文件及两张技术矩阵；未提供论文最终UMAP、最终细胞元数据或Seurat/H5AD对象",
    inchaustiEn:
      "Zenodo provides 17 files and two technical matrices; the final paper UMAP, final cell metadata and Seurat/H5AD object are absent",
  },
  {
    fieldZh: "本站可展示范围",
    fieldEn: "TrypCell display boundary",
    laidlawZh:
      "可忠实展示作者嵌入、细胞注释和可查询表达视图，并明确矩阵层含义",
    laidlawEn:
      "Can faithfully display author embeddings, cell annotations and the queryable expression view while stating matrix-layer meaning",
    inchaustiZh:
      "仅展示来源、矩阵结构和方法审计；不伪造作者最终UMAP或细胞标签",
    inchaustiEn:
      "Limited to provenance, matrix structure and method audit; no invented final author UMAP or cell labels",
  },
] as const;
